export default {
    setInputs: (state, inputs) => { state.inputs = inputs }
}